module.exports = __webpack_public_path__ + "media/icons/scooter-ad7457b5.svg";